import { render, staticRenderFns } from "./DeletedItems.vue?vue&type=template&id=03fa166b&"
import script from "./DeletedItems.vue?vue&type=script&lang=js&"
export * from "./DeletedItems.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports